module.exports = __webpack_public_path__ + "static/media/CourseNewCourse.e8594758.svg";